// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XmwN4","newExpiryDate":"styles_newExpiryDate__2DkvK","footer":"styles_footer__1NGsq"};